var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"error"},_vm._l((_vm.errors['date']),function(msg,index){return _c('li',{key:index},[_vm._v("\n      Date "+_vm._s(msg)+"\n    ")])}),0),_vm._v(" "),_c('ul',{staticClass:"error"},_vm._l((_vm.errors['payment']),function(msg,index){return _c('li',{key:index},[_vm._v("\n      Payment "+_vm._s(msg)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }